import { useContact } from "@/context/ContactContext";
import wordmark from "@/assets/wordmark.png";

const PRODUCTS = ["Bexo", "ActaPay", "Straight", "OpenDeposit"];
const SOCIAL = ["X", "LinkedIn"];

export default function Footer() {
  const { setOpen } = useContact();
  return (
    <footer
      data-testid="footer"
      className="relative bg-white border-t border-black/10 pt-24 pb-10"
    >
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex justify-between pb-12">
          <div>
            <img src={wordmark} alt="OpenDeposit" className="h-7 w-auto" />
            <p className="mt-5 text-zinc-600 max-w-sm text-lg">
              The easiest way to move money between wallets.
            </p>
          </div>

          {/* <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">Products</p>
            <ul className="mt-5 flex flex-col gap-3">
              {PRODUCTS.map((p) => (
                <li key={p}>
                  <a href="#ecosystem" className="text-zinc-600 hover:text-[#0a0a0a] transition-colors" data-testid={`footer-product-${p.toLowerCase()}`}>
                    {p}
                  </a>
                </li>
              ))}
            </ul>
          </div> */}

          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-zinc-500 font-semibold">
              Social
            </p>
            <ul className="mt-5 flex flex-col gap-3">
              {SOCIAL.map((s) => (
                <li key={s}>
                  <a
                    href="#"
                    className="text-zinc-600 hover:text-[#0a0a0a] transition-colors"
                    data-testid={`footer-social-${s.toLowerCase()}`}
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Huge brand wordmark */}
        <div className="mt-20 border-t border-black/10 pt-10">
          <img
            src={wordmark}
            alt="OpenDeposit"
            className="w-full opacity-[0.07] select-none pointer-events-none"
          />
        </div>

        <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-5">
          <p className="text-sm text-zinc-500">
            © 2026 OpenDeposit. All rights reserved.
          </p>
          <div className="flex items-center gap-7 text-sm">
            <button
              onClick={() => setOpen(true)}
              className="text-zinc-500 hover:text-black transition-colors"
              data-testid="footer-contact"
            >
              Contact
            </button>
            <a
              href="#"
              className="text-zinc-500 hover:text-black transition-colors"
              data-testid="footer-privacy"
            >
              Privacy
            </a>
            <a
              href="#"
              className="text-zinc-500 hover:text-black transition-colors"
              data-testid="footer-terms"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
